import "./textArea.scss";
import { Input } from "antd";
const { TextArea } = Input;

type AntTextAreasProps = {
  value?: any;
  placeHolder?: any;
  className?: any;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  name?: any;
  onKeyUp?: any;
  maxLength?: any;
  disabled?: any;
  showCount?: any;
  defaultValue?: any;
  onFocus?: any;
  onBlur?: any;
};

type AntTextAreasState = {};

const AntTextAreas = ({
  disabled,
  value,
  placeHolder,
  className,
  onChange,
  name,
  onBlur,
  onFocus,
  onKeyUp,
  maxLength,
  showCount,

}: AntTextAreasProps) => {
  const handleChange = (e: any) => {
    onChange(e);
    e.preventDefault();
  };
  return (
    <>
      <TextArea
        value={value}
        placeholder={placeHolder}
        disabled={disabled}
        className={className}
        maxLength={maxLength}
        onChange={handleChange}
        onKeyUp={onKeyUp}
        onBlur={onBlur}
        onFocus={onFocus}
        name={name}
        showCount={showCount}
        autoSize={{ minRows: 3, maxRows: 16 }}
      />
      <div className={className}></div>
    </>
  );
};

export { AntTextAreas };
